module.exports = __webpack_public_path__ + "fonts/SegoeUI.c4021b95.woff2";